import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    menuPaper: {
      padding: 0,
      minHeight: 280,
      maxHeight: 556,
    },
    menuList: {
      width: 'fit-content',
      minWidth: 420,
      maxWidth: 420,
    },
    menuListImage: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gap: theme.spacing(1.75),
    },
    buttonsWrapper: {
      padding: theme.spacing(2),
    },
    menuCardsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(1),
    },
    menuCards: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
    searchField: {
      width: '100%',
      marginBottom: theme.spacing(0.5),
      height: 40,
      '&$extraMarginBottom': {
        marginBottom: theme.spacing(1.5),
      },
    },
    extraMarginBottom: {},
    buttonHeader: {
      width: '100%',
      marginBottom: theme.spacing(1.5),
    },
  }),
  { name: 'PromptMenu' }
);
